import { kea } from 'kea'

import sceneLogic from '~/scenes/search/logic'

export default kea({
  connect: {
    props: [sceneLogic, ['filter']]
  }
})
